import React from "react";

const T = "#00c896";
const N = "#0f2040";
const F = "system-ui,sans-serif";

// ── Hero Dashboard Illustration ──────────────────────────────────────────────
const HeroDashboard = () => (
  <svg viewBox="0 0 1100 420" fill="none" xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="1100" height="420" fill={N} rx="16"/>
    {/* Sidebar */}
    <rect width="64" height="420" fill="rgba(255,255,255,0.04)"/>
    {["◉","⊡","⊞","◈","⊟"].map((ic,i) => (
      <g key={i}>
        <rect x="8" y={80+i*56} width="48" height="36" rx="8"
          fill={i===0 ? "rgba(0,200,150,0.18)" : "transparent"}/>
        <text x="32" y={103+i*56} fontSize="14" textAnchor="middle"
          fill={i===0 ? T : "rgba(255,255,255,0.25)"} fontFamily={F}>{ic}</text>
      </g>
    ))}
    {/* Top bar */}
    <rect x="64" width="1036" height="44" fill="rgba(255,255,255,0.03)"/>
    <text x="84" y="27" fontSize="12" fontWeight="700" fill="rgba(255,255,255,0.7)" fontFamily={F}>TrustEngine</text>
    <text x="200" y="27" fontSize="11" fill="rgba(255,255,255,0.3)" fontFamily={F}>/ Case Studies</text>
    <text x="200" y="27" fontSize="11" fill="rgba(255,255,255,0.3)" fontFamily={F}>/ Case Studies</text>
    <rect x="960" y="10" width="120" height="24" rx="6" fill="rgba(0,200,150,0.15)"/>
    <text x="1020" y="26" fontSize="10" fontWeight="700" fill={T} textAnchor="middle" fontFamily={F}>Live Dashboard</text>

    {/* ── KPI Cards row ── */}
    {[
      { label: "Verifications Today", val: "12,847", delta: "+18%", color: T },
      { label: "Avg Response Time",   val: "1.4s",   delta: "-22ms", color: T },
      { label: "Fraud Blocked",        val: "234",    delta: "today",  color: "#f97316" },
      { label: "Uptime SLA",           val: "99.97%", delta: "30d avg", color: T },
    ].map((k, i) => (
      <g key={i}>
        <rect x={84+i*246} y={58} width={232} height={88} rx="10"
          fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
        <text x={104+i*246} y={84} fontSize="10" fill="rgba(255,255,255,0.4)" fontFamily={F}>{k.label}</text>
        <text x={104+i*246} y={114} fontSize="26" fontWeight="800" fill="white" fontFamily={F}>{k.val}</text>
        <rect x={218+i*246} y={120} width={78} height={16} rx="8" fill={k.color} opacity="0.15"/>
        <text x={257+i*246} y={131} fontSize="9" fontWeight="700" fill={k.color} textAnchor="middle" fontFamily={F}>{k.delta}</text>
      </g>
    ))}

    {/* ── Verification volume chart ── */}
    <rect x="84" y="162" width="490" height="230" rx="10"
      fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <text x="104" y="188" fontSize="12" fontWeight="700" fill="rgba(255,255,255,0.8)" fontFamily={F}>Verification Volume (7d)</text>
    {/* Chart bars */}
    {[65,82,54,90,76,95,88].map((h, i) => {
      const barH = h * 1.4;
      return (
        <g key={i}>
          <rect x={120+i*58} y={360-barH} width="36" height={barH} rx="4"
            fill={i===5 ? T : "rgba(0,200,150,0.25)"}/>
          <text x={138+i*58} y={372} fontSize="8" fill="rgba(255,255,255,0.3)"
            textAnchor="middle" fontFamily={F}>{["Mon","Tue","Wed","Thu","Fri","Sat","Sun"][i]}</text>
        </g>
      );
    })}
    {/* Y-axis gridlines */}
    {[0,1,2,3].map(i => (
      <line key={i} x1="104" y1={230+i*36} x2="554" y2={230+i*36}
        stroke="rgba(255,255,255,0.05)" strokeWidth="1"/>
    ))}

    {/* ── Live feed panel ── */}
    <rect x="590" y="162" width="480" height="230" rx="10"
      fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <text x="610" y="188" fontSize="12" fontWeight="700" fill="rgba(255,255,255,0.8)" fontFamily={F}>Live Verification Feed</text>
    <circle cx="740" cy="184" r="4" fill={T}/>
    <text x="748" y="188" fontSize="9" fill={T} fontFamily={F}>LIVE</text>
    {[
      { name: "Budi S.",    type: "eKYC",  score: "99.2", status: "PASS", color: T },
      { name: "Rina K.",    type: "AML",   score: "Clear","status": "PASS", color: T },
      { name: "Ahmad F.",   type: "eKYC",  score: "71.4", status: "REVIEW", color: "#f59e0b" },
      { name: "Siti M.",    type: "OCR",   score: "98.8", status: "PASS", color: T },
      { name: "Doni P.",    type: "AML",   score: "—",    status: "BLOCK", color: "#ef4444" },
    ].map((row, i) => (
      <g key={i}>
        <rect x="590" y={202+i*36} width="480" height="36"
          fill={i%2===0 ? "rgba(255,255,255,0.02)" : "transparent"}/>
        <circle cx="618" cy={220+i*36} r="12" fill="rgba(255,255,255,0.08)"/>
        <text x="618" y={224+i*36} fontSize="9" fill="rgba(255,255,255,0.6)"
          textAnchor="middle" fontFamily={F}>{row.name.charAt(0)}</text>
        <text x="640" y={217+i*36} fontSize="10" fontWeight="600"
          fill="rgba(255,255,255,0.8)" fontFamily={F}>{row.name}</text>
        <text x="640" y={229+i*36} fontSize="8"
          fill="rgba(255,255,255,0.3)" fontFamily={F}>{row.type}</text>
        <text x="790" y={223+i*36} fontSize="11" fontWeight="700"
          fill="rgba(255,255,255,0.6)" textAnchor="middle" fontFamily={F}>
          {row.score !== "—" ? `${row.score}%` : "—"}
        </text>
        <rect x="850" y={210+i*36} width="64" height="18" rx="9"
          fill={row.color} opacity="0.15"/>
        <text x="882" y={222+i*36} fontSize="8" fontWeight="700"
          fill={row.color} textAnchor="middle" fontFamily={F}>{row.status}</text>
      </g>
    ))}

    {/* ── Bottom status bar ── */}
    <rect x="64" y="398" width="1036" height="22" fill="rgba(0,200,150,0.06)"/>
    <circle cx="84" cy="409" r="4" fill={T}/>
    <text x="94" y="413" fontSize="9" fill={T} fontFamily={F}>All systems operational</text>
    <text x="980" y="413" fontSize="9" fill="rgba(255,255,255,0.25)" fontFamily={F}>Last updated: just now</text>
  </svg>
);

// ── Result Chart ─────────────────────────────────────────────────────────────
const ResultChart = () => (
  <svg viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "100%" }}>
    <rect width="480" height="220" fill="#f8fafc" rx="12"/>
    <text x="24" y="32" fontSize="13" fontWeight="700" fill={N} fontFamily={F}>Before vs After TrustEngine</text>
    {[
      { label: "KYC Onboarding Time", before: 72, after: 3, unit: "hours → 90s", barScale: 1 },
      { label: "Drop-off Rate",        before: 68, after: 26, unit: "% → %", barScale: 1 },
      { label: "Fraud Attempt Block",  before: 40, after: 94, unit: "% → %", barScale: 1, invert: true },
      { label: "Ops Cost per Check",   before: 85, after: 12, unit: "K → K IDR", barScale: 1 },
    ].map((row, i) => {
      const y = 56 + i * 42;
      const maxW = 220;
      return (
        <g key={i}>
          <text x="24" y={y + 4} fontSize="10" fill="rgba(15,32,64,0.55)" fontFamily={F}>{row.label}</text>
          {/* Before */}
          <rect x="24" y={y+10} width={(row.before/100)*maxW} height="10" rx="5" fill="#ef4444" opacity="0.3"/>
          <text x={(24+(row.before/100)*maxW)+6} y={y+19} fontSize="9" fontWeight="700" fill="#ef4444" fontFamily={F}>Before</text>
          {/* After */}
          <rect x="24" y={y+24} width={(row.after/100)*maxW} height="10" rx="5" fill={T} opacity="0.7"/>
          <text x={(24+(row.after/100)*maxW)+6} y={y+33} fontSize="9" fontWeight="700" fill={T} fontFamily={F}>After</text>
        </g>
      );
    })}
    {/* Legend */}
    <rect x="360" y="190" width="10" height="10" rx="2" fill="#ef4444" opacity="0.4"/>
    <text x="375" y="200" fontSize="9" fill="rgba(15,32,64,0.5)" fontFamily={F}>Before</text>
    <rect x="410" y="190" width="10" height="10" rx="2" fill={T} opacity="0.7"/>
    <text x="425" y="200" fontSize="9" fill="rgba(15,32,64,0.5)" fontFamily={F}>After</text>
  </svg>
);

// ── Check Icon ────────────────────────────────────────────────────────────────
const Check = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
    <circle cx="10" cy="10" r="10" fill="rgba(0,200,150,0.12)"/>
    <path d="M6 10l3 3 5-5" stroke={T} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ── Main Component ────────────────────────────────────────────────────────────
const ProjectDetailsSection: React.FC = () => {
  const outcomes = [
    "KYC onboarding time cut from 3 days to under 90 seconds",
    "42% reduction in drop-off rate during identity verification",
    "12,000+ fraud attempts blocked per month with 0.3% false positives",
    "OJK eKYC compliance achieved with full audit trail",
    "99.9% API uptime across all production environments",
    "Ops cost per verification reduced by 86% vs manual process",
    "Passive liveness detection with 3D anti-spoofing enabled",
    "Real-time AML/PEP/sanctions screening integrated in same API call",
  ];

  const timeline = [
    { step: "01", title: "API Integration", desc: "REST API integrated into the client's onboarding flow in under 4 hours using the TrustEngine SDK.", duration: "Day 1" },
    { step: "02", title: "Sandbox Testing", desc: "Full end-to-end testing in sandbox environment with synthetic KTP/selfie pairs across 6 edge cases.", duration: "Day 2–3" },
    { step: "03", title: "Production Go-Live", desc: "Deployed to production with feature flag rollout — 10% → 50% → 100% traffic in 72 hours.", duration: "Day 4–7" },
    { step: "04", title: "Optimization", desc: "Tuned liveness threshold and OCR confidence scores based on real traffic data to cut false rejections by 61%.", duration: "Week 2" },
  ];

  return (
    <section style={{ background: "#ffffff", paddingBottom: 100 }}>

      {/* ── Hero Illustration ── */}
      <div style={{ background: N, padding: "0 0 0" }}>
        <div className="container" style={{ padding: "40px 0 0" }}>
          <div style={{ borderRadius: "16px 16px 0 0", overflow: "hidden", boxShadow: "0 24px 64px rgba(0,0,0,0.25)" }}>
            <HeroDashboard />
          </div>
        </div>
      </div>

      <div className="container" style={{ paddingTop: 64 }}>

        {/* ── Meta tags ── */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 40 }}>
          {[
            { label: "Industry", val: "Fintech & Lending" },
            { label: "Country", val: "Indonesia" },
            { label: "Services", val: "eKYC · AML · OCR" },
            { label: "Completed", val: "Q1 2025" },
          ].map((m, i) => (
            <div key={i} style={{
              padding: "8px 20px", borderRadius: 24, background: "#f8fafc",
              border: "1px solid rgba(15,32,64,0.08)", fontSize: 13,
            }}>
              <span style={{ color: "rgba(15,32,64,0.4)", marginRight: 6 }}>{m.label}:</span>
              <span style={{ fontWeight: 700, color: N }}>{m.val}</span>
            </div>
          ))}
        </div>

        {/* ── Overview ── */}
        <h2 style={{ fontSize: 32, fontWeight: 800, color: N, marginBottom: 20, lineHeight: 1.25 }}>
          Digital onboarding at scale —<br />from 3 days to 90 seconds
        </h2>
        <p style={{ color: "rgba(15,32,64,0.6)", lineHeight: 1.85, fontSize: 16, maxWidth: 780, marginBottom: 20 }}>
          A leading fintech lender in Indonesia needed to replace their manual KYC process — which required physical branch visits and took up to 3 business days — with a fully digital, OJK-compliant onboarding flow that could handle 10,000+ applications per day.
        </p>
        <p style={{ color: "rgba(15,32,64,0.6)", lineHeight: 1.85, fontSize: 16, maxWidth: 780, marginBottom: 60 }}>
          TrustEngine's eKYC API was integrated directly into the client's mobile app, combining passive liveness detection, 1:1 face matching against KTP photos, and automated document OCR — all in a single API call returning a verification result in under 2 seconds.
        </p>

        {/* ── KPI Highlight row ── */}
        <div style={{
          display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 20, marginBottom: 72,
          padding: "36px 40px", background: N, borderRadius: 16,
        }}>
          {[
            { val: "90s", label: "End-to-end verification", sub: "down from 3 days" },
            { val: "42%", label: "Drop-off reduction", sub: "vs previous flow" },
            { val: "12K+", label: "Fraud attempts blocked", sub: "per month" },
            { val: "86%", label: "Cost reduction", sub: "per verification" },
          ].map((k, i) => (
            <div key={i} style={{ textAlign: "center", padding: "0 16px", borderRight: i < 3 ? "1px solid rgba(255,255,255,0.08)" : "none" }}>
              <div style={{ fontSize: 36, fontWeight: 900, color: T, marginBottom: 6 }}>{k.val}</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "rgba(255,255,255,0.8)", marginBottom: 4 }}>{k.label}</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)" }}>{k.sub}</div>
            </div>
          ))}
        </div>

        {/* ── 2-col: results + chart ── */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, marginBottom: 72, alignItems: "start" }}>
          <div>
            <span style={{
              display: "inline-block", padding: "4px 14px", borderRadius: 20, marginBottom: 16,
              background: "rgba(0,200,150,0.1)", border: "1px solid rgba(0,200,150,0.25)",
              fontSize: 12, fontWeight: 700, color: "#00a07a",
            }}>Outcomes</span>
            <h3 style={{ fontSize: 24, fontWeight: 800, color: N, marginBottom: 24 }}>What we delivered</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 14 }}>
              {outcomes.map((text, i) => (
                <li key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <Check />
                  <span style={{ fontSize: 14, color: "rgba(15,32,64,0.7)", lineHeight: 1.6 }}>{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div style={{ borderRadius: 12, overflow: "hidden", border: "1px solid rgba(15,32,64,0.07)", boxShadow: "0 4px 24px rgba(15,32,64,0.06)" }}>
            <ResultChart />
          </div>
        </div>

        {/* ── Integration timeline ── */}
        <div style={{ marginBottom: 80 }}>
          <span style={{
            display: "inline-block", padding: "4px 14px", borderRadius: 20, marginBottom: 16,
            background: "rgba(0,200,150,0.1)", border: "1px solid rgba(0,200,150,0.25)",
            fontSize: 12, fontWeight: 700, color: "#00a07a",
          }}>Integration Timeline</span>
          <h3 style={{ fontSize: 24, fontWeight: 800, color: N, marginBottom: 40 }}>Live in under 1 week</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 24 }}>
            {timeline.map((t, i) => (
              <div key={i} style={{
                padding: "28px 24px", borderRadius: 14, background: "#f8fafc",
                border: "1px solid rgba(15,32,64,0.07)", position: "relative",
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: "50%",
                  background: N, display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 13, fontWeight: 800, color: T, marginBottom: 16,
                }}>{t.step}</div>
                <div style={{ fontSize: 11, color: T, fontWeight: 700, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>{t.duration}</div>
                <h4 style={{ fontSize: 16, fontWeight: 800, color: N, marginBottom: 10 }}>{t.title}</h4>
                <p style={{ fontSize: 13, color: "rgba(15,32,64,0.55)", lineHeight: 1.65, margin: 0 }}>{t.desc}</p>
                {i < 3 && (
                  <div style={{
                    position: "absolute", right: -13, top: "50%", transform: "translateY(-50%)",
                    width: 24, height: 24, borderRadius: "50%",
                    background: T, display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 12, color: "white", zIndex: 1,
                  }}>→</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* ── Quote / Testimonial ── */}
        <div style={{
          padding: "48px 56px", borderRadius: 16, background: "linear-gradient(135deg, #0f2040 0%, #1a3460 100%)",
          position: "relative", overflow: "hidden",
        }}>
          <div style={{ fontSize: 80, color: T, opacity: 0.15, position: "absolute", top: 8, left: 32, lineHeight: 1, fontFamily: "Georgia, serif" }}>"</div>
          <p style={{ fontSize: 20, fontWeight: 600, color: "white", lineHeight: 1.7, marginBottom: 24, maxWidth: 700, position: "relative" }}>
            TrustEngine cut our onboarding time by 98% and gave us the compliance confidence we needed to scale. Our fraud rate dropped immediately in the first week.
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: T, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 800, color: N }}>R</div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "white" }}>Rian Hidayat</div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.45)" }}>CEO, Aggre Capital</div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProjectDetailsSection;
